import { Chantier } from '@/models/Chantier';

export interface ProjetListState {
    projetList: Chantier[];
    page: number;
    pages: number;
    filter: string;
    isLoading: boolean;
    error: boolean;
    scroll: number;
    projetId: number;
}

export const initialState: ProjetListState = {
    projetList: [],
    pages: 0,
    page: 0,
    filter: '',
    isLoading: false,
    error: false,
    scroll: 0,
    projetId: 0,
};

export const state : ProjetListState = {
    ...initialState
};
